import type { BoggleLetterAdjacencyMode } from '~/boggle/config/playground'

export type BoggleChallengePathMode = 'continuous-path' | 'free' | 'non-adjacent-path'

export const BOGGLE_CHALLENGE_PATH_MODE_LABELS = {
  'continuous-path': 'Continuous',
  free: 'Free',
  'non-adjacent-path': 'No Neighbors',
} satisfies Record<BoggleChallengePathMode, string>

export const BOGGLE_CHALLENGE_PATH_MODE_DESCRIPTIONS = {
  'continuous-path': 'Path must connect adjacent tiles',
  free: 'No restrictions on pathing',
  'non-adjacent-path': 'Path must skip neighboring tiles',
} satisfies Record<BoggleChallengePathMode, string>

export const BOGGLE_CHALLENGE_PATH_MODE_TO_ADJACENCY = {
  'continuous-path': 'adjacent',
  free: 'free',
  'non-adjacent-path': 'non-adjacent',
} satisfies Record<BoggleChallengePathMode, BoggleLetterAdjacencyMode>

export function getBoggleChallengePathModeAdjacency(
  pathMode: BoggleChallengePathMode,
) {
  return BOGGLE_CHALLENGE_PATH_MODE_TO_ADJACENCY[pathMode]
}
